/* src/app/features/details/components/details-series/details-series.scss */
.episodes-list:has(asset-episode-card:first-child .badge-container) {
  padding-top: 28px;
}
:host ::ng-deep .season-select.p-select {
  border-radius: 18px;
}
/*# sourceMappingURL=details-series.css.map */
